import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import ExternalApprovalPage from './pages/approval/ExternalApprovalPage';
import ApprovalActionPage from './pages/approval/ApprovalActionPage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Approval Routes */}
        <Route path="/external/approval" element={<ExternalApprovalPage />} />
        <Route path="/external/approval/action" element={<ApprovalActionPage />} />

        {/* Default */}
        <Route path="/" element={
          <div className="h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-indigo-50">
            <div className="text-center">
              <h1 className="text-3xl font-bold text-slate-800 mb-2">SAG Web Hub</h1>
              <p className="text-sm text-slate-400">C# Integration Platform</p>
            </div>
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
